<template>
  <div class="dashboard-container">
    <h1>Dashboard</h1>
    <el-table
      v-if="canGetPreDealPost"
      v-loading="isLoading"
      :data="list"
      border
      stripe
    >
      <el-table-column
        label="Date"
        prop="date"
        min-width="100"
      />

      <el-table-column
        label="Time"
        prop="time"
        min-width="80"
      />

      <el-table-column
        label="Subject"
        prop="subject"
        min-width="200"
      />

      <el-table-column
        label="Merchant"
        prop="merchant"
        min-width="100"
      />

      <el-table-column
        label="Brand"
        prop="brand"
        min-width="100"
      />

      <el-table-column
        :label="$t('table.action')"
        fixed="right"
        align="center"
        width="100"
      >
        <template #default="{ row }">
          <div class="button-group">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="handleCreateDealPost(row)"
            />
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="handleDeleteItem(row)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import store from '../../store'

import DashboardService from '../../api/dashboard'
import PreDealPostService from '../../api/pre-deal-post'

export default {
  name: 'Dashboard',
  data() {
    return {
      isLoading: false,
      list: [],
    }
  },
  mounted() {
    this.getPreDealPostList()
  },
  computed: {
    canGetPreDealPost() {
      return (store.getters['user/id'] === 1)
    },
  },
  methods: {
    async getPreDealPostList() {
      this.isLoading = true

      try {
        const { data } = await PreDealPostService.list()
        
        this.list = data
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    async handleCreateDealPost(item) {
      this.$router.push({ path: '/deal-post/create', query: { pre_deal_post_id: item.id } })
    },
    async handleDeleteItem(item) {
      await PreDealPostService.delete(item.id)
      this.$router.go(0)
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  margin-left: 20px;
  margin-right: 20px;
}
</style>
